// Module
var code = "<div id=\"info-video\"> <video src=\"\" id=\"info-player-src\" webkit-playsinline autoplay=\"\" muted=\"\" playsinline=\"\" type=\"video/webm\"></video> </div>";
// Exports
export default code;